import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  dialogOpen: false,
  sessionId: null,
  verificationId: null,
};

const livenessSlice = createSlice({
  name: 'liveness',
  initialState,
  reducers: {
    setLivenessState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetLivenessState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const { setLivenessState, resetLivenessState } = livenessSlice.actions;

export default livenessSlice.reducer;
